import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from '../hooks';
export const OperationSelector = (props) => {
    const devices = useAppSelector(state => state.definitions.devices);
    const device = devices[props.transmitter_id];
    if (device == undefined) {
        return null;
    }
    const options = [];
    switch (device.transmitter_kind) {
        case 'onoff':
            options.push(_jsx("option", { value: "on", children: "P\u00E5" }, "on"));
            options.push(_jsx("option", { value: "off", children: "Av" }, "off"));
            break;
        case 'dim':
            for (let i = 1; i <= 16; i++) {
                options.push(_jsxs("option", { value: 'dim ' + i, children: ["Dim ", i] }, i));
            }
            break;
    }
    return (_jsx("select", { name: props.name, value: props.value, onChange: props.onChange, children: options }));
};
